import { each, filterL, go, mapC } from "fxjs/es";
export const endCopy = async (self, copyTargetImageEl) => {
  if (self._copy_source_grid_id == null) {
    throw new Error(`먼저 복사를 시작해주세요.`);
  }
  const copy_source_grid = self._grids.get(self._copy_source_grid_id);
  if (copy_source_grid == null) {
    throw new Error(`복사 대상을 찾을 수 없습니다.`);
  }
  const copy_source_target_image_el = (() => {
    const { target_image_el: copy_source_target_image_el } = copy_source_grid;
    if (copy_source_target_image_el == null) {
      throw new Error("복사할 이미지를 찾을 수 없습니다.");
    }
    return copy_source_target_image_el;
  })();
  const empty_grid_layer_el = self._getEmptyGridLayerElThrowable();
  const copy_source_grid_layer_el = self._getCopySourceGridLayerElThrowable();
  const copy_destination_unselected_empty_grid_layer_el =
    self._getCopyDestinationUnselectedEmptyGridLayerElThrowable();
  const copy_destination_unselected_existing_grid_layer_el =
    self._getCopyDestinationUnselectedExistingGridLayerElThrowable();
  const copy_destination_selected_grid_layer_el =
    self._getCopyDestinationSelectedGridLayerElThrowable();
  await go(
    self._grids.values(),
    filterL(({ copy_destination_selected_grid_el }) =>
      copy_destination_selected_grid_layer_el.contains(
        copy_destination_selected_grid_el
      )
    ),
    mapC(async ({ id }) => ({
      id,
      target_image_el: await copyTargetImageEl({
        id,
        target_image_el: copy_source_target_image_el,
      }),
    })),
    each(({ id, target_image_el }) =>
      self.setTargetImage({
        id,
        target_image_el,
      })
    )
  );
  each(
    ({
      target_image_el,
      empty_grid_el,
      copy_source_grid_el,
      copy_destination_unselected_empty_grid_el,
      copy_destination_unselected_existing_grid_el,
      copy_destination_selected_grid_el,
    }) => {
      if (copy_source_grid_layer_el.contains(copy_source_grid_el)) {
        copy_source_grid_layer_el.removeChild(copy_source_grid_el);
      }
      if (
        copy_destination_unselected_empty_grid_layer_el.contains(
          copy_destination_unselected_empty_grid_el
        )
      ) {
        copy_destination_unselected_empty_grid_layer_el.removeChild(
          copy_destination_unselected_empty_grid_el
        );
      }
      if (
        copy_destination_unselected_existing_grid_layer_el.contains(
          copy_destination_unselected_existing_grid_el
        )
      ) {
        copy_destination_unselected_existing_grid_layer_el.removeChild(
          copy_destination_unselected_existing_grid_el
        );
      }
      if (
        copy_destination_selected_grid_layer_el.contains(
          copy_destination_selected_grid_el
        )
      ) {
        copy_destination_selected_grid_layer_el.removeChild(
          copy_destination_selected_grid_el
        );
      }
      if (target_image_el == null) {
        empty_grid_layer_el.appendChild(empty_grid_el);
      }
    }
  )(self._grids.values());
};
